import React, { useEffect, useState } from 'react'
import './search.css'
import useTranslation from '../../../hooks/use-translation'
import useBoolean from '../../../hooks/use-boolean'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import { getLocationFromPincode, getAddressComponentFromLatLong } from '../../../utils/get-location/utils'
import { useAppState } from '../../../contexts/appState'
import { useIsMobile } from '../../../hooks/breakpoints'

const Search = ({ projects, setSearchKeyword, getCentersList, setSearchKey, setUserLocationFromDetect, userLocationFromDetect, setUserLocationFromPincode }) => {
  const { t } = useTranslation()
  const [isOpen, open, close] = useBoolean(false)
  const [pincode, setPincode] = useState('400701')
  const [disableButton, setbuttonDisable] = useState(true)
  const [{ location }, dispatch] = useAppState()
  const [searchInput, setSearchInput] = useState('')
  const isMobile = useIsMobile()

  const handleInputChange = (event) => {
    const query = event.currentTarget.value
    setSearchInput(query)
    if (query.length >= 3) {
      setSearchKeyword.value = event.currentTarget.value
      setSearchKey(event.currentTarget.value)
    }
    if (query.length <= 1) {
      setSearchKeyword.value = event.currentTarget.value
      setSearchKey(event.currentTarget.value)
      getCentersList(true)
    }
  }

  function positionError (error) {
    if (error.PERMISSION_DENIED) {
      console.log('Error: permission denied')
      console.log('Geolocation is not enabled. Please enable to use this feature.')
    } else {
      console.log('Other kind of error: ' + error)
    }
  }
  const dialogHead = () => (
    <div className='pincode-popup'>
      <img src='/icons/location-blue.svg' alt='location icon' />
      <div style={isMobile ? { marginTop: '0.5rem', color: '#3F3E44', fontSize: '1rem' } : { marginTop: '0.5rem', color: '#3F3E44', fontSize: '1.25rem' }}>{t('CHANGE_PINCODE')}</div>
    </div>
  )

  const handleChange = (e) => {
    if (e.target.value.length === e.target.maxLength) {
      setbuttonDisable(false)
      setPincode(e.target.value)
    } else {
      setbuttonDisable(true)
    }
  }

  const setLimit = (e) => {
    if (e.target.value.length > e.target.maxLength) {
      e.target.value = e.target.value.slice(0, e.target.maxLength)
    }
  }

  const latLongFromPincode = async () => {
    try {
      const resp = await getLocationFromPincode(pincode)
      const { latitude = '', longitude = '', city = '' } = resp
      setUserLocationFromPincode.latitude = latitude
      setUserLocationFromPincode.longitude = longitude
      setUserLocationFromPincode.city = city
      dispatch({ type: 'UPDATE_BOOKING', bookingData: { lat: latitude, long: longitude, pincode: pincode, city: city } })
      dispatch({ type: 'UPDATE_LOCATION', locationData: { latitudeFromPincode: latitude, longitudeFromPincode: longitude, pincode: pincode, city: city } })
      setUserLocationFromDetect({ usePincode: true, pincode })
    } catch (e) {
      console.log(e)
    }
  }
  useEffect(() => {
    latLongFromPincode()
  }, [])

  const doneButtonClick = () => {
    setSearchInput('')
    close()
    setbuttonDisable(true)
    latLongFromPincode()
  }

  const dialogBody = () => (
    <p className='pincode-body'>
      <input type='number' className='pincode-input' maxLength='6' onInput={setLimit} onChange={handleChange} />
      <button className={disableButton ? (isMobile ? 'pincode-button-disable-mobile' : 'pincode-button-disable')
        : (isMobile ? 'pincode-button-active-mobile' : 'pincode-button-active')} onClick={() => {
        doneButtonClick()
      }}>{t('DONE')}</button>
    </p>
  )

  const pincodePopup = () => (
    <Dialog
      open={isOpen}
      onClose={close}
      aria-labelledby='dialog-title'
      PaperProps={{
        style: {
          marginLeft: '22px',
          marginRight: '22px',
          width: '28.125em',
          background: '#ffffff 0% 0% no-repeat padding-box',
          boxShadow: '16px 0px 24px #00000029',
          borderRadius: '0.625em'
        }
      }}
    >
      {dialogHead()}
      <DialogContent css={{
        paddingLeft: '1rem',
        paddingRight: '1rem',
        width: '300px',
        wordBreak: 'break-word'
      }}
      >
        <DialogContentText css={{
          fontFamily: 'jioType-Medium',
          fontSize: '14px',
          color: '#000000',
          marginTop: '-10px'
        }}
        >
          {dialogBody()}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  )

  function getLocation () {
    setSearchInput('')
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition, positionError)
    } else {
      console.log('Geolocation is not supported by this browser.')
    }
  }

  const showPosition = async (position) => {
    if (userLocationFromDetect.city) {
      return
    }
    const result = await getAddressComponentFromLatLong(position.coords.latitude, position.coords.longitude)
    setPincode(result.pincode)
    setUserLocationFromDetect({ latitude: position.coords.latitude, longitude: position.coords.longitude, city: result.city, usePincode: false, pincode: result.pincode })
  }

  const pinCodeSection = () => (
    <div className='pincode-section'>
      <div onClick={open}>
        <img src='/icons/location.svg' alt='location' />
        <span className='pincode_search' style={{ marginRight: '10px' }}>{t('PINCODE')}</span>
        <span>{pincode}</span>
        <img src='/icons/arrow-ios-downward-fill.svg' alt='down arrow' style={{ marginLeft: '0.25rem' }} />
      </div>
      <button className='detect_button' onClick={() => getLocation()}>
        <img src='/icons/location-2.svg' alt='location' />
        <span style={{ marginLeft: '0.25rem' }}>{t('DETECT')}</span>
      </button>
    </div>
  )
  const pinCodeSectionMobile = () => (
    <div className='pincode-section-mobile'>
      <div onClick={open} style={{ display: 'flex', flexDirection: 'row', justifySelf: 'center' }}>
        <img src='/icons/location.svg' alt='location' style={{ height: '1.5rem', width: '1.5rem', marginRight: '0.25rem', alignSelf: 'center' }} />
        <div style={{ marginRight: '0.625rem' }}>
          <div className='pincode_search' style={{ fontSize: '10px' }}>{t('PINCODE')}</div>
          <div style={{ fontSize: '14px' }}>{pincode}</div>
        </div>
        <img src='/icons/arrow-ios-downward-fill.svg' alt='down arrow' style={{ marginLeft: '0.25rem' }} />
      </div>
      <button className='detect_button' style={{ padding: '0.25rem' }} onClick={() => getLocation()}>
        <img src='/icons/location-2.svg' alt='location' style={{ height: '1.125rem', width: '1.125rem' }} />
        <span style={{ marginLeft: '0.25rem', fontSize: '0.75rem' }}>{t('DETECT')}</span>
      </button>
    </div>
  )

  return (<>
    <div className='search-container'>
      {isMobile ? pinCodeSectionMobile() : pinCodeSection()}
      <div className={isMobile ? 'search-section-mobile' : 'search-section'}>
        <img src='/icons/search.svg' style={isMobile ? { height: '1.25rem', width: '1.25rem' } : {}} />
        <input type='text' className='search-input' value={searchInput} placeholder={t('SEARCH_CENTERS')} onChange={handleInputChange} />
      </div>
    </div >
    {pincodePopup()}
  </>
  )
}
export default Search
